// Polis, the candidates tab and their popularity (10 October 2026).
export default {
  titre: 'Candidate popularity',
  luLe: 'Read on {jour}',
  jamaisLu: 'Not read yet',
  lecture: 'Score from 0 to 100 based on what is said about each, 50 being neutral',
  suivi: 'Every evening',
  lire: 'Read now',
  enCours: 'Reading',
  premiereEnCours: 'First reading under way: Orion reads the past week for each candidate.',
  aucuneLecture: 'No reading yet. The first one reads the past week for each candidate.',
  courbeAria: 'Each candidate’s score, day by day',
  legende: 'Highlight a candidate',
  vue: { aria: 'View', radar: 'Radar', suivi: 'Tracking' },
  mesure: { aria: 'Overlap by', personas: 'Personas', entourage: 'Circle' },
  recoupement: {
    bouton: 'Overlaps',
    aria: '{a} and {b} overlap at {pct}%',
    titre: 'Overlap',
    personasPct: 'of their voters come from the same personas',
    sansPersonas: 'Their voters do not come from the same personas.',
    communs: 'Personas in common',
    seul: 'Only with {nom}',
    rienSeul: 'Nothing of their own',
    entouragePct: 'porosity between their electorates',
    procheDe: '{pct}% of {de}’s voters have someone close who votes {vers}.',
    sansEntourage: 'Their voters rarely mix.',
    recoupePersonas: 'Their voters overlap with',
    recoupeEntourage: 'Their voters mix with',
  },
  et: 'and',
  radarAria: 'The candidates on the radar, from left to right',
  lectureRadar: {
    projection: 'At the centre, those the projection ranks highest; the bigger the head, the more they are talked about.',
    attente: 'The projection will place the candidates once the first wave is complete; the bigger the head, the more they are talked about.',
    personas: 'A line joins two candidates whose voters come from the same personas.',
    entourage: 'A line joins two candidates whose voters mix.',
  },
  projection: {
    titrePct: 'First round',
    titreSieges: 'Projection',
    pct: '{n}%',
    sieges: '{n} seats',
    fourchette: '{bas} ~ {haut}',
    second: 'chance of reaching the run-off',
    seuil: 'chance of clearing the threshold',
    colonne: 'Projection',
  },
  note: { titre: 'What is being said', colonne: 'Score' },
  classement: 'Ranking',
  electeurs: {
    // Their personas, each with a voice, and you can talk to them (11 October 2026).
    titre: 'Their personas',
    citation: '“{texte}”',
    tous: 'All their voters: {profil}',
    sources: 'Built from the twins’ votes and Orion’s intelligence, including {n} studies and sources. | Built from the twins’ votes and Orion’s intelligence, including {n} study or source. | Built from the twins’ votes and Orion’s intelligence, including {n} studies and sources.',
    parler: 'Talk to them',
    parlerA: 'Talk to the “{segment}” voters',
    qui: { femme: 'woman', homme: 'man', ans: '{n}' },
    age: 'median age {n}',
    femmes: '{n}% women',
    tropPeu: 'Too few voters in the last wave to describe them.',
    sansVague: 'Voters are described after a voting wave.',
    source: 'Projection, voters and overlaps: {vague}.',
    sourceEnCours: 'Voters and overlaps: {vague}, in progress.',
    // The election's Sonar (11 October 2026).
    interroger: 'Talk to all their voters',
  },
  changerPhoto: 'Change {nom}’s photo',
  photoOrion: 'Use Orion’s photo again',
  surCent: 'out of 100',
  surSemaine: 'over 7 days',
  surJour: 'since yesterday',
  pasEncoreLu: 'Not read yet.',
  deLaVoix: 'share of voice',
  courbeCandidat: '{nom}’s score over the period',
  repartitionAria: '{favorable}% favourable, {neutre}% neutral, {defavorable}% unfavourable',
  favorable: 'favourable',
  neutre: 'neutral',
  defavorable: 'unfavourable',
  ceQuiSeDit: 'What people say',
  peuDeMatiere: 'Little material that day: the score moves fast.',
  chargement: 'Reading the candidates…',
  erreur: 'The candidates could not be read.',
  fermer: 'Close',
}
